export function digitLength(num: number) {
  const eSplit = num.toString().split(/[eE]/);
  const len = (eSplit[0].split('.')[1] || '').length - +Number(eSplit[1] || 0);
  return len > 0 ? len : 0;
}

export function precisionAdd(...nums: number[]) {
  const digitNums = nums.map(digitLength);
  const baseNum = 10 ** Math.max(...digitNums);
  return (
    nums.reduce(
      (total, item) => total + precisionMultiplier(item, baseNum),
      0
    ) / baseNum
  );
}

export function precisionMultiplier(num: number, times: number) {
  let m = 0;
  const s1 = num.toString(),
    s2 = times.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {
    // throw new Error(e as string);
  }
  try {
    m += s2.split('.')[1].length;
  } catch (e) {
    // throw new Error(e as string);
  }
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  );
}

export function isValidNumeric(n: string | number) {
  return !isNaN(parseFloat(n as string)) && isFinite(n as number);
}

export function thousands(num: number | string, forceDecimals = true) {
  const number = typeof num === 'string' ? parseFloat(num) : num;

  if (isNaN(number)) {
    return 'Invalid input';
  }

  if (Number.isInteger(number) && !forceDecimals) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatNumberWithDecimals(
  input: string | number,
  n = 2
): string {
  // 将输入转换为数字类型
  const numValue: number =
    typeof input === 'string' ? parseFloat(input) : input;

  if (isNaN(numValue)) {
    return 'Invalid input';
  }

  // 检查是否为整数
  if (Number.isInteger(numValue)) {
    return numValue.toString();
  }
  return numValue.toFixed(n);
}

export const formatPercentage = (percentage?: string) => {
  if (!percentage) return '';
  return `${Math.round(Number(percentage) * 10000) / 100}%`;
};

export const calculateWithPrecision = (
  num1: string,
  num2: string,
  operation: '+' | '-' = '+'
): string => {
  const n1 = parseFloat(num1);
  const n2 = parseFloat(num2);

  const result = operation === '+' ? n1 + n2 : n1 - n2;

  const num1Decimals = (num1.split('.')[1] || '').length;
  const num2Decimals = (num2.split('.')[1] || '').length;
  const maxDecimals = Math.max(num1Decimals, num2Decimals);

  // 使用toFixed方法保留精度
  return result.toFixed(maxDecimals);
};
